/* =============================================
   Amanah LLC — Shopify Theme JS
   ============================================= */

(function () {
  'use strict';

  /* --- Sticky Navbar --- */
  function initNavbar() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    function onScroll() {
      if (window.scrollY > 20) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --- Mobile Menu --- */
  function initMobileMenu() {
    var hamburger = document.querySelector('.hamburger');
    var mobileMenu = document.querySelector('.mobile-menu');
    if (!hamburger || !mobileMenu) return;

    var isOpen = false;

    function toggleMenu() {
      isOpen = !isOpen;
      mobileMenu.classList.toggle('open', isOpen);
      hamburger.setAttribute('aria-expanded', String(isOpen));

      // Swap icon
      var iconOpen = hamburger.querySelector('.icon-open');
      var iconClose = hamburger.querySelector('.icon-close');
      if (iconOpen && iconClose) {
        iconOpen.style.display = isOpen ? 'none' : 'block';
        iconClose.style.display = isOpen ? 'block' : 'none';
      }
    }

    hamburger.addEventListener('click', toggleMenu);

    // Close when a link is clicked
    var links = mobileMenu.querySelectorAll('a');
    links.forEach(function (link) {
      link.addEventListener('click', function () {
        if (isOpen) toggleMenu();
      });
    });
  }

  /* --- Accordion FAQ --- */
  function initAccordion() {
    var items = document.querySelectorAll('.accordion-item');
    items.forEach(function (item) {
      var trigger = item.querySelector('.accordion-trigger');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');

        // Close all open items
        items.forEach(function (other) {
          other.classList.remove('open');
        });

        // Toggle the clicked one
        if (!isOpen) {
          item.classList.add('open');
        }
      });
    });
  }

  /* --- Scroll Animations (IntersectionObserver) --- */
  function initScrollAnimations() {
    if (!('IntersectionObserver' in window)) {
      // Fallback: show all immediately
      document.querySelectorAll('.fade-up').forEach(function (el) {
        el.classList.add('visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    document.querySelectorAll('.fade-up').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* --- Page produit --- */
  function initProductPage() {
    var form = document.getElementById('product-form');
    if (!form) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

    /* --- Galerie miniatures --- */
    var mainImg = document.querySelector('.product-main-image');
    document.querySelectorAll('.product-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        document.querySelectorAll('.product-thumb').forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (mainImg) {
          mainImg.src = thumb.dataset.src;
          mainImg.alt = thumb.dataset.alt || '';
        }
      });
    });

    /* --- Sélecteur de variantes --- */
    var variantInput = document.getElementById('product-variant-id');
    var variantsEl  = document.getElementById('product-variants-json');

    if (variantInput && variantsEl) {
      var variants;
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) { variants = null; }

      if (variants) {
        function getSelectedOptions() {
          var opts = [];
          form.querySelectorAll('[data-option-index]').forEach(function (radio) {
            if (radio.checked) {
              opts[parseInt(radio.dataset.optionIndex, 10)] = radio.dataset.optionValue;
            }
          });
          return opts;
        }

        function findVariant(options) {
          return variants.find(function (v) {
            return v.options.every(function (opt, i) { return opt === options[i]; });
          });
        }

        function updateVariant() {
          var options = getSelectedOptions();
          var variant = findVariant(options);
          if (!variant) return;

          variantInput.value = variant.id;

          var priceEl = document.querySelector('.product-price:not(.product-price--compare)');
          if (priceEl && variant.price) {
            priceEl.textContent = (variant.price / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
          }

          var availEl = document.querySelector('.product-availability');
          var addBtn  = document.getElementById('product-add-btn');
          if (availEl) {
            if (variant.available) {
              availEl.className = 'product-availability product-availability--in';
              availEl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg> Début des démarches dès validation du paiement';
              if (addBtn) { addBtn.disabled = false; addBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Ajouter au panier'; }
            } else {
              availEl.className = 'product-availability product-availability--out';
              availEl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg> Actuellement indisponible';
              if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Indisponible'; }
            }
          }
        }

        form.querySelectorAll('.product-option-radio').forEach(function (radio) {
          radio.addEventListener('change', updateVariant);
        });
      }
    }

    /* --- Anti-doublon : ajout AJAX unique --- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var addBtn    = document.getElementById('product-add-btn');
      var idInput   = form.querySelector('[name="id"]');
      var variantId = idInput ? Number(idInput.value) : 0;
      if (!variantId) return;

      /* Désactiver le bouton pendant la requête */
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Ajout en cours…';
      }

      /* 1. Lire le panier actuel */
      fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var alreadyIn = cart.items.some(function (item) {
            return Number(item.variant_id) === variantId;
          });

          /* 2a. Déjà présent → aller directement au panier */
          if (alreadyIn) {
            window.location.href = root + 'cart';
            return;
          }

          /* 2b. Pas encore présent → ajouter avec quantité 1 */
          fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          })
          .then(function (r) {
            if (!r.ok) { return r.json().then(function (d) { throw new Error(d.description || 'Erreur ajout panier'); }); }
            return r.json();
          })
          .then(function () {
            window.location.href = root + 'cart';
          })
          .catch(function (err) {
            console.error('[Amanah] cart/add.js error:', err);
            if (addBtn) {
              addBtn.disabled = false;
              addBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Ajouter au panier';
            }
          });
        })
        .catch(function (err) {
          console.error('[Amanah] cart.js read error:', err);
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg> Ajouter au panier';
          }
        });
    });
  }

  /* --- Page panier : protection quantité > 1 --- */
  function initCartPage() {
    if (!document.querySelector('.cart-page')) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var overQty = cart.items.filter(function (item) { return item.quantity > 1; });
        if (overQty.length === 0) return;

        /* Ramener chaque ligne à 1 */
        Promise.all(overQty.map(function (item) {
          return fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: item.key, quantity: 1 })
          });
        })).then(function () {
          window.location.reload();
        });
      })
      .catch(function (err) { console.error('[Amanah] cart protection error:', err); });
  }

  /* --- Smooth anchor scroll (Tarifs / FAQ) --- */
  function initAnchorScroll() {
    document.querySelectorAll('a[data-anchor]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var anchorId = link.getAttribute('data-anchor');
        var target   = document.getElementById(anchorId);

        // Cible présente sur la page courante → scroll fluide sans rechargement
        if (target) {
          e.preventDefault();
          var header     = document.getElementById('site-header');
          var offset     = header ? header.offsetHeight + 8 : 82;
          var targetTop  = target.getBoundingClientRect().top + window.pageYOffset - offset;

          window.scrollTo({ top: targetTop, behavior: 'smooth' });

          // Fermer le menu mobile si ouvert
          var mobileMenu = document.querySelector('.mobile-menu');
          if (mobileMenu && mobileMenu.classList.contains('open')) {
            var hamburger = document.querySelector('.hamburger');
            if (hamburger) hamburger.click();
          }
        }
        // Si target absent (autre page), le href="/#ancre" prend le relais naturellement
      });
    });
  }

  /* --- DOMContentLoaded bootstrap --- */
  document.addEventListener('DOMContentLoaded', function () {
    initNavbar();
    initMobileMenu();
    initAnchorScroll();
    initAccordion();
    initScrollAnimations();
    initProductPage();
    initCartPage();
  });
})();
